import { Component, ElementRef, NgZone, OnInit, Renderer2 } from '@angular/core';
import { InactivityService } from "./Services/inactive-service.service";
import { AuthService } from "./Services/auth.service";
import { Constant } from "./Shared/Constant";
import * as moment from "moment/moment";
import * as alertify from "alertifyjs";
import { Router } from '@angular/router';
import { NavbarService } from './Services/navbar-service/navbar.service';
import {ApiServiceService} from "./Services/api-service.service";
import {InactivityServiceService} from "./Services/inactivity-service.service";
import AOS from 'aos';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private renderer: Renderer2,
    private el: ElementRef,
    private apiService: ApiServiceService,
    private router: Router,
    private navbarService: NavbarService,
    private inactivityService: InactivityServiceService,
    private readonly ngZone: NgZone
  ) {}
  title = 'tax_2.0';

  isSideNavOpen = false;
  fullPageRoutes = ['/404', '/401']
  isFullPageView: boolean = false;

  
  ngOnInit(): void {
    this.initAOS();
    alertify.set("notifier", "position", "top-center");

    this.navbarService.getSidebarState().subscribe((isSideNavOpen: boolean) => {
      this.isSideNavOpen = isSideNavOpen;
    });
    this.subscribeToRouteChanges()
    if (!sessionStorage.getItem('visited')) {
      this.saveVisit();
      sessionStorage.setItem('visited', 'true');
    }

    const today = new Date().toISOString().split('T')[0]; // 2026-03-06
    const lastVisit = localStorage.getItem('lastVisitDate');

    if (lastVisit !== today) {
      this.saveVisit();
      localStorage.setItem('lastVisitDate', today);
    }
    this.inactivityService.startWatching();
  }

  initAOS() {
    if (typeof window === 'undefined') return; // SSR guard
    this.ngZone.runOutsideAngular(
      () => {
        AOS.init({
          // Keep these
          startEvent: 'DOMContentLoaded',
          initClassName: 'aos-init',
          animatedClassName: 'aos-animate',
          useClassNames: false,
          disableMutationObserver: false,
          debounceDelay: 50,
          easing: 'ease',
          anchorPlacement: 'top-bottom',

          // Change these
          once: true,           // ✅ Animate once, stay visible. Better UX + performance
          mirror: false,        // Keep false (only relevant if once=false)
          offset: 50,           // ✅ Trigger closer to viewport entry
          duration: 800,        // ✅ Snappier feel
          throttleDelay: 16,    // ✅ ~60fps check rate
          delay: 0,             // Fine, or set 100 for staggered reveals
        });
      }
    )
  }

  subscribeToRouteChanges() {
    this.router.events.subscribe(event => {
      const currentPath = this.router.url.split('?')[0];
      this.isFullPageView = this.fullPageRoutes.includes(currentPath);
    })
  }
  

  closeSideBar() {
    this.navbarService.closeSidebar();
  }

  get isExecutiveRoute(): boolean {
    // Get the first segment of the route
    const firstSegment = this.router.url.split('/')[1];
    return firstSegment === 'executive';
  }

  saveVisit(){
    console.log("visitors tracking");
    this.apiService.loginPost_("/auth/utility/track/visitors", {}).subscribe(
        (response) => {
          console.log(response);
        }
    )
  }
}
